import React from 'react';
import { Modal as WixModal } from '@wix/design-system';

const Modal = (config) => <WixModal {...config} />;

export default Modal;
